import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { API_ciudadanos } from "../../config/apiConfig";
import {
  FaIdCard,
  FaPenToSquare,
  FaDownload,
  FaEye,
  FaUpload,
  FaFile,
} from "react-icons/fa6";
import Navbar from "../../components/Navbar";
import Estados from "../../components/cv/Estados";
import Datos from "../../components/cv/Datos";
import Ocupaciones from "../../components/cv/Ocupaciones";
import Idiomas from "../../components/cv/Idiomas";
import Digital from "../../components/cv/Digital";
import Habilidades from "../../components/cv/Habilidades";
import SobreMi from "../../components/cv/SobreMi";
import Experiencia from "../../components/cv/Experiencia";
import Formacion from "../../components/cv/Formacion";
import Competencias from "../../components/cv/Competencias";
import Documentos from "../../components/cv/Documentos";
import Social from "../../components/cv/Social";
import "./css/Curriculum.css";
import { useAuth } from "../../context/AuthContext";

const Curriculum = () => {
  const { user, role } = useSelector((state) => state.auth);
  const { token } = useAuth();
  const [usuario, setUsuario] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const res = await fetch(API_ciudadanos, {
          headers: {
            "x-auth-token": token,
          },
        });
        const data = await res.json();

        const normalize = (str) =>
          str
            ?.normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase();

        const encontrado = data.find(
          (c) =>
            normalize(c.email) === normalize(user?.email) ||
            (normalize(c.name) === normalize(user?.name) &&
              normalize(c.lastName) === normalize(user?.lastName))
        );

        if (encontrado) setUsuario(encontrado);
      } catch (error) {
        console.error("Error al cargar datos del usuario:", error);
      }
    };

    if (user?.name) {
      fetchUserData();
    }
  }, [user, token]);

  const fileInputRef = useRef(null); //Referencia al input del archivo

  const handleUploadClick = () => {
    fileInputRef.current.click(); // Simula clic en el input oculto
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file && file.type === "application/pdf") {
      // console.log("Archivo seleccionado:", file.name);
      // Aquí puedes enviar el archivo al servidor con fetch o axios
    } else {
      alert("Por favor selecciona un archivo PDF.");
    }
  };

  if (!usuario) return <p className="ml-10">Cargando datos del ciudadano...</p>;

  return (
    <>
      <Navbar />

      <main className="main-user curriculum">
        <section className="cabecera between">
          <h1 className="titulo-user align-center">CURRICULUM VITAE</h1>
          <div className="botones flex">
            <button
              className="boton align-center verde"
              onClick={handleUploadClick}
            >
              <FaUpload />
              Subir CV en pdf
            </button>
            <input
              type="file"
              accept=".pdf"
              style={{ display: "none" }}
              ref={fileInputRef}
              onChange={handleFileChange}
            />
            <button className="boton align-center verde">
              <FaDownload />
              Descargar CV
            </button>
            <button className="boton align-center verde">
              <FaIdCard />
              Repositorio de mis CVs
            </button>
          </div>
        </section>

        <section className="cv between">
          <div className="columna-izquierda column">
            <Estados rol={role} usuario={usuario} setUsuario={setUsuario} />
            <Datos rol={role} usuario={usuario} setUsuario={setUsuario} />
            <Ocupaciones usuario={usuario} />
            <Idiomas usuario={usuario} />
            <Digital usuario={usuario} />
            <Habilidades usuario={usuario} />
          </div>

          {/* COLUMNA DERECHA */}
          <div className="columna-derecha column">
            <SobreMi usuario={usuario} />
            <Experiencia usuario={usuario} />
            <Formacion usuario={usuario} />
            <Competencias usuario={usuario} />
            <Documentos usuario={usuario} />
            <Social usuario={usuario} />
          </div>
        </section>
      </main>
    </>
  );
};

export default Curriculum;
